<script>
  import { domainName, record } from '../stores.js';
</script>

<div class="record-box record-tags">
  <div id="headingRaw" class="box-label">
    <h5>Discovered Tags</h5>
    <p>The tags and their definitions pulled from the record for {$domainName}</p>
    <button type="button" class="btn-collapse" data-toggle="collapse" data-target="#collapseTags" aria-expanded="true" aria-controls="collapseTags" aria-label="Close"></button>
  </div>
  <div id="collapseTags" class="box-detail collapse show" aria-labelledby="headingRaw">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Tags</th>
          <th>Value</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        {#each $record.dmarc.tags as tag }
          {@const data = tag[0].split('=')}
          <tr>
            <td>{data[0]}</td>
            <td>{data[1]}</td>
            <td>{tag[1]}</td>
          </tr>
        {/each}
      </tbody>
    </table>
  </div>
</div>

<style>
th:first-child {
  width: 17%;
}
th:last-child {
  width: 50%;
}
</style>
